import React from 'react';
import { Col, Form, Row, Select, Typography } from 'antd';
import { useTranslation } from 'react-i18next';
import Helpers from 'helpers';

const InfoSection = ({ shops, isNew, period, name }) => {

  const { t } = useTranslation();
  return (
    <Row gutter={24}>
      <Col span={6}>
        <Typography.Title level={3}>{t('Info')}</Typography.Title>
      </Col>
      <Col span={9}>
      
        <Form.Item label={t('Data pubblicazione')} name='period'>
        { period }
          {/* <Input
            style={{ width: '100%' }}
            disabled={true}
          /> */}
          {/*<DatePicker*/}
          {/*  disabled={!isNew}*/}
          {/*  format={'DD MMMM YYYY'}*/}
          {/*  style={{ width: '100%' }}*/}
          {/*/>*/}
        </Form.Item>
      </Col>
      <Col offset={6} span={9}>
        <Form.Item
          label={t('Insegna')}
          optionFilterProp={'label'}
        >
          <Select
          value={name}
            disabled={true}
            {...Helpers.addSearchProps()}
          >
                <Select.Option key={name} value={name}>
                  {name}
                </Select.Option>
          </Select>
        </Form.Item>
      </Col>
    </Row>
  );
};

export default React.memo(InfoSection);
